import { Observable } from 'rxjs';

export enum ResourceType {
  General = 0,
  Group = 1,
  Profile = 2,
  Pool = 3,
  WLProfile = 4,
}

export interface IPermission {
  id: number;
  name: string;
  resourceId?: number;
  resourceType: ResourceType;
  isAllowed: boolean;
  parentId?: number;
  category: string;
}

export interface IRole {
  id: number;
  name: string;
  externalId: string;
  isSystemAdmin: boolean;
  isProtected: boolean;
  userGroupKind: string;
  connectionId: number;
  connectionName: string;
  domainName: string;
  mcReferenceId: string;
  permissions$: Observable<IPermission[]>;
  mcInstanceId?: number;
  inherits: boolean;
  inheritsFrom: number[];
}

export interface IRolePermission {
  roleId: number;
  roleName: string;
  isSystemAdmin: boolean;
  groupKind: string;
  connectionId: number;
  connectionName: string;
  permissions: Array<IPermission>;
  inherits: boolean;
  inheritsFrom: number[];
}

export interface IPermissionUpdate {
  id: number;
  isAllowed: boolean;
}

export interface IRolePermissionUpdate {
  roleId: number;
  permissions: Array<IPermission>;
}

export interface IPermissionUpdate {
  id: number;
  isAllowed: boolean;
}

export interface IResource {
  resourceId: number;
  resourceName: string;
  permissionState?: PermissionState | null;
}

export interface IResourcePermission {
  resourceId: number;
  resourceName: string;
  permissions: IPermission[];
}

export enum PermissionState {
  None = 0,
  Partial = 1,
  Full = 2,
}

export interface PermissionsUI {
  state: PermissionState;
  permission?: IPermission;
  permissions: IPermission[];
  category?: string;
  parentId?: number;
}

export interface IUserResourcePermission {
  resourceId: number;
  permissionId: number;
  permissionName: string;
}
